/**
 * StatusBar Component - Bottom status bar
 */

interface StatusBarProps {
  message: string
  type: 'info' | 'success' | 'warning' | 'error' | 'loading'
}

export function StatusBar({ message, type }: StatusBarProps) {
  const getStatusIcon = () => {
    switch (type) {
      case 'success':
        return '✓'
      case 'warning':
        return '⚠'
      case 'error':
        return '✗'
      case 'loading':
        return '⟳'
      default:
        return '●'
    }
  }

  const getStatusColor = () => {
    switch (type) {
      case 'success':
        return 'text-term-success'
      case 'warning':
        return 'text-term-warning'
      case 'error':
        return 'text-term-error'
      case 'loading':
        return 'text-term-info animate-pulse'
      default:
        return 'text-term-textDim'
    }
  }

  return (
    <footer className="border-t border-term-border bg-term-bg px-4 py-2 flex items-center justify-between text-sm">
      <div className="flex items-center gap-2">
        <span className={getStatusColor()}>{getStatusIcon()}</span>
        <span className="text-term-text">{message}</span>
      </div>
      <div className="flex items-center gap-4 text-term-textDim text-xs">
        <span>[/] Search</span>
        <span>[1-8] Switch Tabs</span>
        <span>[Esc] Cancel</span>
        <span>[Ctrl+Q] Quit</span>
      </div>
    </footer>
  )
}
